<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <div class="personal-details">
        <h4 class="personal-details-title">COMPOSITION</h4>
        <div cdkDropListGroup class="composition-block">
          <div class="example-container-left">
            <h2>Raw Material</h2>
            <input type="text" class="form-control" placeholder="Search product" [(ngModel)]="searchBoxTxt" (ngModelChange)="onSearchChange()">
            <hr>
            <div cdkDropList [cdkDropListData]="filteredProductList" class="example-list1" (cdkDropListDropped)="drop($event)">
              <div class="example-box1" *ngFor="let item of filteredProductList; let i = index" cdkDrag>
                <span>{{item.name}}</span>
                <span style="cursor: pointer; color: #03a84e;" (click)="addToDone(item, i)" title="Add to composition">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                  </svg>
                </span>
              </div>
            </div>
          </div>

          <div class="example-container-right">
            <h2>Formula Details</h2>
            <div class="row">
              <div class="col-md-12 col-lg-12">
                <input type="text" placeholder="Enter formula name" [(ngModel)]="productName" class="form-control">
              </div>
              <div class="col-md-2 col-lg-2">
                <input type="number" min="1" placeholder="Batch quantity" class="form-control" [(ngModel)]="batchQuantity" oninput="validity.valid||(value='');">
              </div>
              <div class="col-md-2 col-lg-2">
                <input type="number" min="0" placeholder="Batch price" class="form-control" [(ngModel)]="batchPrice" oninput="validity.valid||(value='');">
              </div>
              <div class="col-md-4 col-lg-4">
                <div class="form-group ">
                  <ng-multiselect-dropdown [placeholder]="'Select UOMs'" [settings]="uomDropdownSettings"
                    [data]="uomDropdownList" [(ngModel)]="uomSelectedList" class="form-control"
                    style="padding: 0;border: none" (onSelect)="onItemSelect($event)"
                    (onSelectAll)="onSelectAll($event)">
                  </ng-multiselect-dropdown>
                </div>
              </div>
              <div class="col-md-4 col-lg-4" *ngIf="uomSelectedList.length != 0">
                <select class="form-control" [(ngModel)]="isDefault">
                  <option value="" disabled selected hidden>-- Select default UOM --</option>
                  <option *ngFor="let uom of uomSelectedList" [value]="uom.uomMasterId">{{uom.uomName}}</option>
                </select>
              </div>
            </div>

            <div cdkDropList [cdkDropListData]="done" class="example-list" (cdkDropListDropped)="drop($event)">
              <div class="example-box" *ngFor="let item of done; let i = index" cdkDrag>
                <div class="row input-data align-items-end position-relative">
                  <div class="col-md-11 col-lg-11">
                    <p class="font-weight-bold mb-2">{{item.name}}</p>
                  </div>
                  <div class="col-md-1 col-lg-1 text-right">
                    <span style="cursor: pointer; color: #dc3545;" (click)="removeFromDone(i)" title="Remove item">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                        <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                      </svg>
                    </span>
                  </div>
                  <div class="col-md-2 col-lg-2">
                    <label>Price:</label>
                    <input type="text" readonly class="form-control" value="{{item.price}}">
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <label>UOM:</label>
                    <select class="form-control" (change)="uomChange($event, i)" [(ngModel)]="item.uom">
                      <option value="" disabled selected hidden>-- Select UOM --</option>
                      <option *ngFor="let uom of item.supportedUOM" [value]="uom.uomName">{{uom.uomName}}</option>
                    </select>
                  </div>

                  <div class="col-md-2 col-lg-2">
                    <label>Quantity:</label>
                    <input type="number" min="1" class="form-control" (keyup)="amountChanged()"
                      (change)="amountChanged()" [(ngModel)]="item.qty" oninput="validity.valid||(value='');">
                  </div>

                  <div class="col-md-2 col-lg-2">
                    <label>Sub Total:</label>
                    <input readonly type="text" class="form-control" value="{{item.price * item.qty}}">
                  </div>
                </div>
              </div>
              
              <div class="text-center p-3 text-muted" *ngIf="done.length === 0">
                Drag and drop raw materials here
              </div>
            </div>
            
            <div class="submit-footer">
              <p class="font-weight-bold">Total Amount: {{amount}}</p>
              <div>
                <button class="view-b" data-toggle="modal" data-target="#viewModal" [disabled]="done.length === 0">View</button>
                <button class="add-b" (click)="add()">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="viewModal" *ngIf="done.length != 0" tabindex="-1" data-backdrop="static"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">COMPOSITION SUMMARY</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg"
              viewBox="0 0 16 16">
              <path
                d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
            </svg>
          </span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table table-striped" style="margin-bottom: 0;padding-bottom: 0;">
          <thead>
            <tr>
              <th style="width: 60%;">Product</th>
              <th style="width: 10%;text-align: center;">UOM</th>
              <th style="width: 10%;text-align: center;">Price</th>
              <th style="width: 10%;text-align: center;">Quantity</th>
              <th style="width: 10%;text-align: center;">Sub Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let product of done;let i = index">
              <th>{{product.name}}</th>
              <th style="text-align: center;">{{product.uom}}</th>
              <th style="text-align: center;">{{product.price}}</th>
              <th style="text-align: center;">{{product.qty}}</th>
              <th style="text-align: center;">{{product.price * product.qty}}</th>
            </tr>
          </tbody>
        </table>
        <div class="modal-footer" style="padding-right: 0;">
          <span class="font-weight-bold">Total: {{amount}}</span>
          <button type="button" id="closeModalButton2" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
